// import { Box } from '@material-ui/core'
// import React, { useEffect, useState } from 'react'
// import { useCompanyAdmin } from '../../hooks/CompanyAdmin/useCompanyAdmin'
// import { useCompanyConfig } from '../../hooks/CompanyConfiguration/useCompanyConfig'
// import CustomButton from '../CustomButton'
// import CustomDialog from '../CustomDialog'
// import HeadingWithCloseIcon from '../HeadingWithCloseIcon'
// import CustomAddForm from '../version-4/MasterForms/CustomAddForm'
// import WeitageDialogueHeader from './WeitageDialogueHeader'
// import MenuItem from '@material-ui/core/MenuItem'
// import Select from '@material-ui/core/Select'
// export default function WeitageDialogue({ open, handleClose, form, passwordRequirement }) {
//   const [state, setstate] = useState({
//     minCharacter: 0,
//     maxCharacter: 0,
//     minNumber: 0,
//     minSpecial: 0,
//     minUppercase: 0,
//     minLowercase: 0,
//     // minSpecial:0,
//   })
//   const [items, setItems] = useState(['Attendance', 'Audit', 'Sales', 'Learning'])
//   const [inputs, setInputs] = useState([])
//   const [selectedInputs, setSelectedInputs] = useState([])
//   const { updateCompanyAccount, getLoggedInUser, loggedUser } = useCompanyConfig()

//   useEffect(() => {
//     if (passwordRequirement) {
//       setstate({ ...passwordRequirement })
//     }
//   }, [passwordRequirement])
//   useEffect(() => {
//     getLoggedInUser()
//   }, [])

//   const inputfields = [
//     {
//       label: 'Attendance',
//       value: state.minCharacter,
//       name: 'minCharacter',
//       type: 'NUMBER',
//       grid: 6,
//       noValidate: true,
//     },
//     {
//       label: 'Audit',
//       value: state.maxCharacter,
//       name: 'maxCharacter',
//       type: 'NUMBER',
//       grid: 6,
//       noValidate: true,
//     },
//     { label: 'Sales', value: state.minNumber, name: 'minNumber', type: 'NUMBER', grid: 6, noValidate: true },
//     { label: 'Learning', value: state.minNumber, name: 'minNumber', type: 'NUMBER', grid: 6, noValidate: true },
//   ]
//   const handleGeneratePasswordPolicy = () => {
//     // setForm({ ...form, passwordRequirement: state })
//     updateCompanyAccount({ ...loggedUser, passwordRequirement: state })
//     handleClose()
//   }

//   return (
//     <CustomDialog open={open} handleClose={handleClose}>
//       <HeadingWithCloseIcon heading={`${passwordRequirement ? 'Edit' : 'Generate'} Password Requirement`} handleClose={handleClose} />
//       {/* {
//          items.map((item,index)=>{return(
//          <WeitageDialogueHeader name={item.name} handleChange={(checkboxValue)=>{
//              if(checkboxValue){
//  let selectedInput=inputfields.filter((item1)=>{return(item1.label===item.name)});
//  console.log(selectedInput);
//  setInputs([...inputs,...selectedInput])
//              }else{
//                  let deselected=inputs;
//       let restInputs=           deselected.filter((item1)=>{return(item1.label!==item.name)});
//       console.log(restInputs);
//       setInputs([...restInputs])
//              }

//          }}/>
//          )})
//      }  */}
//       <Select
//         labelId="demo-multiple-name-label"
//         id="demo-multiple-name"
//         value={selectedInputs}
//         multiple
//         onChange={(e) => {
//           let restInputs = e.target.value
//           let filteredInputs = inputfields.filter((item1) => {
//             return restInputs.includes(item1.label)
//           })
//           setSelectedInputs(restInputs)
//           setInputs(filteredInputs)
//           console.log(e.target.value)
//         }}
//         // style={{ minWidth: '100%' }}

//         fullWidth={true}
//       >
//         {items.map((item, index) => (
//           <MenuItem key={index} value={item}>
//             {item}
//           </MenuItem>
//         ))}
//       </Select>
//       <CustomAddForm state={state} setState={setstate} data={inputs} />
//       <Box display="flex" justifyContent="center" marginTop="30px">
//         <Box>
//           <CustomButton text="Cancel" handleSubmit={handleClose} />
//         </Box>
//         <Box>
//           <CustomButton text="Submit" handleSubmit={handleGeneratePasswordPolicy} />
//         </Box>
//       </Box>
//     </CustomDialog>
//   )
// }

import { Box } from '@material-ui/core'
import axios from 'axios'
import React, { useContext, useState } from 'react'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { API } from '../../shared/API'
import CustomButton from '../CustomButton'
import CustomDialog from '../CustomDialog'
import CustomAddForm from '../version-4/MasterForms/CustomAddForm'

export default function WeitageDialogue({ open, handleClose }) {
  const storageItem = JSON.parse(localStorage.getItem('company'))

  const percentages = []

  storageItem &&
    storageItem.weightage &&
    storageItem.weightage.forEach((val) => {
      console.log({ val })
      percentages.push({ [val.module]: val.percentage })
    })

  // const initialState =
  const [data, setData] = useState(
    percentages.length > 0
      ? {
          attendance: Object.values(percentages[0])[0],
          learning: Object.values(percentages[1])[0],
          audit: Object.values(percentages[2])[0],
          sales: Object.values(percentages[3])[0],
        }
      : {
          attendance: '',
          learning: '',
          audit: '',
          sales: '',
        }
  )
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  console.log({ percentages })
  console.log({ data })
  const addWeightage = async (dto = {}) => {
    await axios.post(API.ADD_WEIGHTAGE, dto, header).then((data) => {
      console.log('DATA ', data.data)
      handleClose()
      localStorage.setItem('company', JSON.parse(data.data.company))
    })
  }

  const handleAdd = () => {
    addWeightage({
      weightage: data,
    })
  }

  const inputFields = [
    { label: 'Attendance', value: data.attendance, name: 'attendance', grid: 6, type: 'number' },
    { label: 'Learning', value: data.learning, name: 'learning', grid: 6, type: 'number' },
    { label: 'Audit', value: data.audit, name: 'audit', grid: 6, type: 'number' },
    { label: 'Sales', value: data.sales, name: 'sales', grid: 6, type: 'number' },
  ]

  return (
    <div>
      <CustomDialog open={open} handleClose={handleClose} heading="Configure Weightage">
        <CustomAddForm state={data} setState={setData} data={inputFields} />
        <Box display="flex" justifyContent="center" marginTop="30px">
          <Box>
            <CustomButton text="Cancel" handleSubmit={handleClose} />
          </Box>
          <Box>
            <CustomButton text="Submit" handleSubmit={handleAdd} />
          </Box>
        </Box>
      </CustomDialog>
    </div>
  )
}
